import { AuthGuard } from '@/lib/auth/AuthGuard';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router';
import { createBrowserRouter } from 'react-router-dom';

// Lazy load pages for better performance
const Login = lazy(() => import('../pages/auth/Login'));
const Dashboard = lazy(() => import('../pages/dashboard/Dashboard'));
const LettersGenerator = lazy(() => import('../pages/letters-generator/LettersGenerator'));

// Loading component for suspense fallback
const Loading = () => <div className="flex items-center justify-center min-h-screen">Loading...</div>;

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/dashboard" replace />
  },
  {
    path: '/login',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthGuard>
          <Login />
        </AuthGuard>
      </Suspense>
    )
  },
  {
    path: '/dashboard',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthGuard>
          <Dashboard />
        </AuthGuard>
      </Suspense>
    )
  },
  {
    path: '/letters-generator',
    element: (
      <Suspense fallback={<Loading />}>
        <AuthGuard>
          <LettersGenerator />
        </AuthGuard>
      </Suspense>
    )
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />
  }
])
